import React, { useContext } from 'react'
import Modal from 'styled-react-modal'

import { ClickWrapModalContext } from './context'

const StyledModal = Modal.styled({
  width: '95%',
  height: '95%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: 'white',
  padding: '20px',
  '@media(min-width: 576px)': {
    width: '90%',
    height: '90%',
    padding: '40px 40px 20px',
  },
  '@media(min-width: 768px)': {
    width: '75%',
    height: '90%',
  },
})

const ClickWrapModal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [modal, dispatch] = useContext(ClickWrapModalContext)

  const toggleModal = () => {
    dispatch({ type: 'toggleOpen' })
  }

  return (
    <StyledModal
      isOpen={modal.isOpen}
      onBackgroundClick={toggleModal}
      onEscapeKeydown={toggleModal}
    >
      {children}
    </StyledModal>
  )
}

export default ClickWrapModal
